import Store from "../../../../../../Store";
import et from "./images/et.png";

export const mockImages = { et };

export const getMockImage = () => {
  const short = Store.getUserPlatformLangShort();
  return mockImages[short];
};
